import React from "react";
import { Button, Form,Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function Supervision({ nextStep, prevStep }) {
  return (
    <>
    <div className="form-navigator-body">
      <Table bordered responsive>

        <thead>
          <tr className="table-secondary text-center align-middle">
            <th>Description</th>
            <th>Total no of visits  during the month</th>
            <th>TI</th>
            <th>LWS</th>
            <th>One Stop Centre</th>
            <th>Prisons</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>DACO</td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
          </tr>

          <tr>
            <td>DPM/CPM</td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
          </tr>

          <tr>
            <td>DIS/CSO</td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
          </tr>

          <tr>
            <td>DA-M&E</td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
          </tr>

          <tr>
            <td>DA-Accounts</td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
          </tr>

          <tr>
            <td>DA-Programme</td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
          </tr>

          <tr>
            <td>DMDO</td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
          </tr>
        </tbody>
      </Table>

      <Table bordered responsive>

        <thead>
          <tr className="table-secondary text-center align-middle">
            <th>Description</th>
            <th>OCS</th>
            <th>OST center</th>
            <th>ICTC</th>
            <th>SSK</th>
            <th> DSRC</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>DACO</td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
          </tr>

          <tr>
            <td>DPM/CPM</td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
          </tr>

          <tr>
            <td>DIS/CSO</td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
          </tr>

          <tr>
            <td>DA-M&E</td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
          </tr>

          <tr>
            <td>DA-Accounts</td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
          </tr>

          <tr>
            <td>DA-Programme</td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
          </tr>

          <tr>
            <td>DMDO</td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
          </tr>
        </tbody>
      </Table>

      <Table bordered responsive>

        <thead>
          <tr className="table-secondary text-center align-middle">
            <th>Description</th>
            <th>ART Centre</th>
            <th>Link ART Centre</th>
            <th>CSC</th>
            <th>VL lab</th>
            <th>SRL</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>DACO</td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
          </tr>

          <tr>
            <td>DPM/CPM</td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
          </tr>

          <tr>
            <td>DIS/CSO</td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
          </tr>

          <tr>
            <td>DA-M&E</td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
          </tr>

          <tr>
            <td>DA-Accounts</td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
          </tr>

          <tr>
            <td>DA-Programme</td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
          </tr>

          <tr>
            <td>DMDO</td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
          </tr>
        </tbody>
      </Table>

    </div>


      <div className="form-navigate-footer">
        <button onClick={prevStep} className="btn btn-outline-secondary">
          Back
        </button>
        <button onClick={nextStep} className="btn btn-dark border-0">
          Next
        </button>
      </div>
    </>
  );
}
